<div class="dialog-export-columns">
  <header class="dialog-export-columns__header">
    <h2 class="dialog-export-columns__title">
      {{ (data.titleKey || 'exportColumns.dialog.title') | translate }}
    </h2>
    <p class="dialog-export-columns__subtitle">
      {{ (data.subtitleKey || 'exportColumns.dialog.subtitle') | translate }}
    </p>
  </header>

  <main class="dialog-export-columns__body">
    <div class="column-item column-item--select-all">
      <mat-checkbox
        [checked]="allSelected"
        [indeterminate]="someSelected"
        (change)="toggleAll($event.checked)"
        color="primary"
      >
        <span class="column-label">{{ 'exportColumns.dialog.selectAll' | translate }}</span>
      </mat-checkbox>
    </div>

    <mat-divider />

    @for (col of data.columns; track col.key) {
      <div class="column-item">
        <mat-checkbox
          [checked]="selectedKeys.has(col.key)"
          (change)="toggle(col.key, $event.checked)"
          color="primary"
        >
          <span class="column-label">
            {{ col.titleKey ? (col.titleKey | translate) : col.title }}
          </span>
        </mat-checkbox>
        @if (col.sensitive) {
          <ui-atom-sensitive-badge />
        }
      </div>
    }

    @if (selectedKeys.size === 0) {
      <p class="empty-hint">{{ (data.emptyHintKey || 'exportColumns.dialog.emptyHint') | translate }}</p>
    }

    @if (data.noteKey) {
      <p class="info-note">
        <mat-icon class="info-note__icon" aria-hidden="true">info</mat-icon>
        <span>{{ data.noteKey | translate }}</span>
      </p>
    }
  </main>

  <footer class="dialog-export-columns__footer">
    <ui-atom-button
      styling="outlined"
      [withShadow]="false"
      [text]="'exportColumns.dialog.cancel' | translate"
      (buttonClick)="onCancel()"
    />
    <ui-atom-button
      styling="filled"
      [withShadow]="true"
      [disabled]="selectedKeys.size === 0 && !data.allowEmpty"
      [text]="'exportColumns.dialog.continue' | translate"
      (buttonClick)="onContinue()"
    />
  </footer>
</div>
